module.exports = __webpack_public_path__ + "img/recommed-img3.29dcb7d3.jpg";